import { useLazyQuery } from '@apollo/client';
import { ApprovalHistory, ApprovalHistoryVariables } from '../__generated__/ApprovalHistory';
import GET_APPROVAL_HISTORY_DETAILS from '../ApprovalHistory.graphql';

export const useApprovalHistoryLazyQuery = () => {
  const [getApprovalHistory, result] = useLazyQuery<
    ApprovalHistory,
    ApprovalHistoryVariables
  >(GET_APPROVAL_HISTORY_DETAILS, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
  });

  const { data, loading, variables, refetch, error, called } = result;

  return {
    getApprovalHistory,
    data,
    loading,
    variables,
    refetch,
    error,
    called,
  };
};
